/*
 * Replaces the text of the (unbranded) dynamic checkout button with the label
 * set on the buy buttons block. Shopify renders that button itself, so its text
 * can only be changed after it has been inserted into the page.
 */
(function () {
  if (window.__buyNowLabel) return;
  window.__buyNowLabel = true;

  function apply() {
    document.querySelectorAll('[data-buy-now-label]').forEach(function (container) {
      var label = container.getAttribute('data-buy-now-label');
      if (!label) return;
      container.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (button) {
        if (button.textContent.trim() !== label) button.textContent = label;
      });
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      apply();
    }, 30);
  }

  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('DOMContentLoaded', queue);
  window.addEventListener('load', queue);
  queue();
})();
